import { axios } from "../../../../Global";
import nodeinstance from "../../../../nodeInstance";
import { setAppError } from "../../../../store/userSlice";
import {
  candidateStatusTravelling,
  countPaxNotCompleted,
} from "./ArrivalEmployeeBatch";

export const sortAndFilterByPax = (tableData = [], isFiltering = false) => {
  let filteredPax = tableData;
  console.log("pax filter in console",filteredPax)
  if (!isFiltering) {
    filteredPax = tableData.filter((data) => {
      return (
        (countPaxNotCompleted(data?.candidate) > 0 ||
          candidateStatusTravelling(data?.candidate)) &&
        data?.pax > 0
      );
    });
  }

  filteredPax
    .sort((a, b) => {
      const paxA = new Date(a.pax);
      const paxB = new Date(b.pax);
      return paxB - paxA;
    })
    .sort((a, b) => {
      const dateA = new Date(a?.date_of_arrival);
      const dateB = new Date(b?.date_of_arrival);
      return dateB - dateA;
    });

  return filteredPax;
};

export const putArrivalFlightEdit = async (
  body,
  flightId,
  setLoading,
  setData,
  dispatch
) => {
  setLoading(true);

  try {
    const response = await axios.put(
      `/dashboard/arrival-onboarding-flight-edit/${flightId}`,
      body
    );

    if (response.status == 200) {
      const state = response.data.data;
      setData(state?.arrival_batch);
      dispatch(setAppError({ msg: response.data.message, color: "success" }));
    }
    setLoading(false);
    return { completed: true, error: false };
  } catch (error) {
    dispatch(
      setAppError({ msg: error?.response?.data?.message || error?.message })
    );
    setLoading(false);
    return { completed: true, error: true };
  }
};

export const postGroupAction = async (body, setLoading, setData, dispatch) => {
  setLoading(true);
  try {
    // Uses Node backend — mirrors Laravel ArrivalController@action
    const response = await nodeinstance.post(
      `/dashboard/arrival-onboarding/action`,
      body
    );

    if (response.status == 200) {
      const state = response.data.data;
      setData(state?.arrival_batch);
      dispatch(setAppError({ msg: response.data.message, color: "success" }));
    }
    setLoading(false);
    return { completed: true, error: false };
  } catch (error) {
    dispatch(
      setAppError({ msg: error?.response?.data?.message || error?.message })
    );
    setLoading(false);
    return { completed: true, error: true };
  }
};
